import { render, staticRenderFns } from "./activityFile.vue?vue&type=template&id=671eb836&scoped=true"
import script from "./activityFile.vue?vue&type=script&lang=js"
export * from "./activityFile.vue?vue&type=script&lang=js"
import style0 from "./activityFile.vue?vue&type=style&index=0&id=671eb836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671eb836",
  null
  
)

export default component.exports